import { PaymentType } from "./types";

export const CLIENT_ROUTE = '/user-subscriptions';
export const API_ROUTE = '/api/user-subscription'
export const CLIENT_TITLE = 'Худалдан авалт'
export const paymentTypes: { [key in PaymentType]: string } = {
    qpay: 'QPay',
    socialpay: 'Social Pay',
    manual: 'Гараас',
    apple: 'Apple',
    bank: 'Данс',
    google: 'Google'
}